import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { BaseService } from '../base-service';
import { Helpers } from '../../utilities/helpers';
import { App as AppConfig } from '../../config/app';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PlacesSearch extends BaseService {
  
  constructor(
    http: Http
  ) {
    super(http);

    this.setAuthorizationHeaders();
  }

  getPlacesNearBy(lat:number, long:number, category:string, aroundRadius:number) {
    
    let aroundLatLng = lat + ',' + long;
    let count = environment.places_search.result_count;
    let facetFilters = JSON.stringify(category);
    let url =  AppConfig.getPlacesNearByUrl() + Helpers.getQueryParamsString({ aroundLatLng, aroundRadius, count, facetFilters });
    
    let headers:Headers = this.headers;
    
    return this.http.get(url, { headers });
  }
}


// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/services/places-search/places-search.ts